import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, InputLabel } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import useGetAllBaseRole from 'api/accessControl/useGetAllBaseRole/useGetAllBaseRolle';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

const defaultValues = {
  roleGUID: '',
};

const UserChangeBaseRoleModal = ({
  open,
  handleClose,
  changeBaseRoleLoading,
  onChangeBaseRole,
  userGUID,
}) => {
  const [getRoleList, rolesLoading, roleList] = useGetAllBaseRole();
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    if (open) {
      reset(defaultValues);
      getRoleList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, reset]);

  const onSubmit = data => {
    onChangeBaseRole({
      userGUID,
      roleGUID: data.roleGUID,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>تغییر نقش</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl
            variant="standard"
            sx={{ m: 2, minWidth: 300 }}
            error={isSubmitted ? !!errors.roleGUID : false}
          >
            <InputLabel id="change-role-select-label">نقش</InputLabel>
            <Controller
              name="roleGUID"
              control={control}
              rules={{ required: 'انتخاب نقش الزامی است' }}
              render={({ field }) => (
                <Select
                  {...field}
                  labelId="change-role-select-label"
                  label="نقش"
                >
                  {rolesLoading ? (
                    <SpinnerLoader />
                  ) : (
                    roleList.map(role => (
                      <MenuItem
                        value={role.key}
                        key={role.key}
                        sx={{ direction: 'rtl' }}
                      >
                        {role.value}
                      </MenuItem>
                    ))
                  )}
                </Select>
              )}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={changeBaseRoleLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          loading={changeBaseRoleLoading}
        >
          ذخیره
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UserChangeBaseRoleModal;

const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
